/**
 * @desc 保存
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.SystemOrderContractRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/systemOrderContract/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
